import { logout as keycloakLogout } from '../../services/keycloakService';
import { jwtLogout } from '../../services/jwtAuthService';
import { getEnv } from '../../envConfig';
import * as authService from '../../services/authService';
import {
    persistUserSession,
    clearLegacyTokenStorage,
    clearAuthSessionStorage,
    prefetchOrganizationConfig,
} from '../../utils/authSessionStorage';

const AUTH_METHOD = getEnv().AUTH_METHOD || 'keycloak';

export const restoreSession = () => async (dispatch) => {
    dispatch({ type: 'RESTORE_SESSION_PENDING' });
    try {
        const { user, organization_id } = await authService.getSession();
        clearLegacyTokenStorage();
        persistUserSession(user, organization_id);
        await prefetchOrganizationConfig(organization_id);
        dispatch({
            type: 'RESTORE_SESSION_SUCCESS',
            payload: { user },
        });
    } catch (error) {
        clearAuthSessionStorage();
        dispatch({ type: 'RESTORE_SESSION_FAILURE' });
    }
};

export const login = (username, password, otp) => async (dispatch) => {
    try {
        if (AUTH_METHOD === 'jwt') {
            const { jwtLogin } = await import('../../services/jwtAuthService');
            const result = await jwtLogin({ username, password });
            dispatch({
                type: 'LOGIN_SUCCESS',
                payload: { user: result.user },
            });
            return { success: true };
        }

        const { user, organization_id } = await authService.login({ username, password, otp });
        clearLegacyTokenStorage();
        persistUserSession(user, organization_id);
        await prefetchOrganizationConfig(organization_id);

        dispatch({
            type: 'LOGIN_SUCCESS',
            payload: { user },
        });
        return { success: true };
    } catch (error) {
        dispatch({
            type: 'LOGIN_FAILURE',
            payload: error?.response?.data?.errorMessage
                || error?.response?.data?.error
                || error?.data?.errorMessage
                || error?.errorMessage
                || 'Login failed',
        });
        return { success: false };
    }
};

export const logout = () => async (dispatch) => {
    try {
        if (AUTH_METHOD === 'jwt') {
            await jwtLogout();
        } else {
            await keycloakLogout();
        }
    } catch (e) { /* ignore */ }

    clearAuthSessionStorage();
    dispatch({ type: 'LOGOUT' });
};
